import {StyledText} from "../../contenful/types";
import {Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {StyledTextComponent} from "./HeroBannerTwoColumnsComponent";
import {getWidthSlide, navigatePagination, prevNextArrowPosition, slideTransform} from "../../utils/SlideNext";
import PanelSectionJackpotBanner from "./PanelSectionJackpotBanner";
import {useSelector} from "react-redux";
import {AppState} from "../../RootReducer";


interface Props {
    loggedIn: boolean | undefined;
    id: string | undefined;
    itemLength: number | undefined;
    panels: any;
    sectionClassName: string | undefined;
    renderNavigate: any;
    bottomNavigation?: boolean;
}

const PanelSectionFullWidth: React.FC<Props> = (props : Props) => {
    const [mouseOnId, setMouseOnId] = useState('')
    const [mouseOn, setMouseOn] = useState(false)
    const [touchEnd, setTouchEnd] = useState(false)
    const [touchStartXValue, setTouchStartXValue] = useState(0)
    const [touchEndXValue, setTouchEndXValue] = useState(0)
    const [touchStartYValue, setTouchStartYValue] = useState(0)
    const [touchEndYValue, setTouchEndYValue] = useState(0)
    const [touchId, setTouchId] = useState('')
    const isMobile = useSelector((app: AppState)=> app.settings.mobile)

    useEffect(() => {
        // Auto Slide
        const getFullWidthPanelWrapperDesktop = document.querySelectorAll<HTMLElement>(`.container-full-width .panel-wrapper.desktop`)
        for(let i = 0; i < getFullWidthPanelWrapperDesktop.length; i++) {
            const idWrapper = getFullWidthPanelWrapperDesktop[i].getAttribute('id')
            if(idWrapper === props.id && idWrapper != mouseOnId) {
                    const handleInterval = setInterval(() => {
                    const widthPanel = getWidthSlide(getFullWidthPanelWrapperDesktop, false, true)
                    const slideActive = getFullWidthPanelWrapperDesktop[i].getAttribute('slide-active')
                    const slideLength = getFullWidthPanelWrapperDesktop[i].getAttribute('data-items-init')
                    const currPosition = getFullWidthPanelWrapperDesktop[i].getAttribute('position')
                    if(slideActive && slideLength && currPosition) {
                        let slideActiveNum = parseInt(slideActive)
                        let slideLengthNum = parseInt(slideLength)
                        let currPositionNum = parseInt(currPosition)
                        let widthNum = parseInt(widthPanel)
                        let counterIncrement = slideActiveNum+1
                        if (slideActiveNum == slideLengthNum-1) {
                            counterIncrement -= counterIncrement
                        }
                        getFullWidthPanelWrapperDesktop[i].setAttribute('slide-active', `${counterIncrement}`)

                        for(let a = 0; a < getFullWidthPanelWrapperDesktop[i].childNodes.length; a++) {

                            const cNode = (getFullWidthPanelWrapperDesktop[i].childNodes[a] as HTMLElement)?.getAttribute('data-index-number')

                            if(cNode) {
                                if(parseInt(cNode) != counterIncrement) {
                                    (getFullWidthPanelWrapperDesktop[i].childNodes[a] as HTMLElement)?.classList.add('not-active')
                                } else {
                                    (getFullWidthPanelWrapperDesktop[i].childNodes[a] as HTMLElement)?.classList.remove('not-active')
                                }
                            }

                        }
                        if((slideActiveNum < slideLengthNum-1) && (slideActiveNum >= 0)) {
                            getFullWidthPanelWrapperDesktop[i].setAttribute('position', `${currPositionNum-widthNum}`)
                            getFullWidthPanelWrapperDesktop[i].style.transition = `transform 200ms cubic-bezier(0.25, 1, 0.5, 1)`
                            getFullWidthPanelWrapperDesktop[i].style.transform = `translateX(${currPositionNum-widthNum}px)`
                        }
                        if(slideActiveNum === slideLengthNum-1) {
                            setTimeout(() => {
                                getFullWidthPanelWrapperDesktop[i] && getFullWidthPanelWrapperDesktop[i].style.removeProperty('transition')
                                getFullWidthPanelWrapperDesktop[i].style.transform = `translateX(${currPositionNum+((slideLengthNum-1)*widthNum)}px)`
                            }, 200)
                            getFullWidthPanelWrapperDesktop[i].setAttribute('slide-active', `0`)
                            const total = (slideLengthNum-1)*widthNum
                            getFullWidthPanelWrapperDesktop[i] && getFullWidthPanelWrapperDesktop[i].setAttribute('position', `${currPositionNum+total}`)
                            getFullWidthPanelWrapperDesktop[i].style.transition = `transform 200ms cubic-bezier(0.25, 1, 0.5, 1)`
                            getFullWidthPanelWrapperDesktop[i].style.transform = `translateX(${currPositionNum-widthNum}px)`
                        }
                    }
                    navigatePagination(getFullWidthPanelWrapperDesktop[i])
                }, 4000)

                return () => {
                    clearInterval(handleInterval)
                }
            }

        }
        const getFullWidthPanelWrapperMobile = document.querySelectorAll<HTMLElement>(`.mobile-auto-slide .container-full-width .panel-wrapper.mobile`)
        if(getFullWidthPanelWrapperMobile != undefined) {
            for(let i = 0; i < getFullWidthPanelWrapperMobile.length; i++) {
                const idWrapper = getFullWidthPanelWrapperMobile[i].getAttribute('id')
                if(idWrapper === props.id && idWrapper != mouseOnId) {
                        const handleInterval = setInterval(() => {
                        const widthPanel = getWidthSlide(getFullWidthPanelWrapperMobile, false, true)
                        const slideActive = getFullWidthPanelWrapperMobile[i].getAttribute('slide-active')
                        const slideLength = getFullWidthPanelWrapperMobile[i].getAttribute('data-items-init')
                        const currPosition = getFullWidthPanelWrapperMobile[i].getAttribute('position')
                        if(slideActive && slideLength && currPosition) {
                            let slideActiveNum = parseInt(slideActive)
                            let slideLengthNum = parseInt(slideLength)
                            let currPositionNum = parseInt(currPosition)
                            let widthNum = parseInt(widthPanel)
                            let counterIncrement = slideActiveNum+1
                            if (slideActiveNum == slideLengthNum-1) {
                                counterIncrement -= counterIncrement
                            }
                            getFullWidthPanelWrapperMobile[i].setAttribute('slide-active', `${counterIncrement}`)

                            for(let a = 0; a < getFullWidthPanelWrapperMobile[i].childNodes.length; a++) {

                                const cNode = (getFullWidthPanelWrapperMobile[i].childNodes[a] as HTMLElement)?.getAttribute('data-index-number')

                                if(cNode) {
                                    if(parseInt(cNode) != counterIncrement) {
                                        (getFullWidthPanelWrapperMobile[i].childNodes[a] as HTMLElement)?.classList.add('not-active')
                                    } else {
                                        (getFullWidthPanelWrapperMobile[i].childNodes[a] as HTMLElement)?.classList.remove('not-active')
                                    }
                                }

                            }
                            if((slideActiveNum < slideLengthNum-1) && (slideActiveNum >= 0)) {
                                getFullWidthPanelWrapperMobile[i].setAttribute('position', `${currPositionNum-widthNum}`)
                                getFullWidthPanelWrapperMobile[i].style.transition = `transform 200ms cubic-bezier(0.25, 1, 0.5, 1)`
                                getFullWidthPanelWrapperMobile[i].style.transform = `translateX(${currPositionNum-widthNum}px)`
                            }
                            if(slideActiveNum === slideLengthNum-1) {
                                setTimeout(() => {
                                    getFullWidthPanelWrapperMobile[i] && getFullWidthPanelWrapperMobile[i].style.removeProperty('transition')
                                    getFullWidthPanelWrapperMobile[i].style.transform = `translateX(${currPositionNum+((slideLengthNum-1)*widthNum)}px)`
                                }, 200)
                                getFullWidthPanelWrapperMobile[i].setAttribute('slide-active', `0`)
                                const total = (slideLengthNum-1)*widthNum
                                getFullWidthPanelWrapperMobile[i] && getFullWidthPanelWrapperMobile[i].setAttribute('position', `${currPositionNum+total}`)
                                getFullWidthPanelWrapperMobile[i].style.transition = `transform 200ms cubic-bezier(0.25, 1, 0.5, 1)`
                                getFullWidthPanelWrapperMobile[i].style.transform = `translateX(${currPositionNum-widthNum}px)`
                            }
                        }
                        navigatePagination(getFullWidthPanelWrapperMobile[i])
                    }, 4000)

                    return () => {
                        clearInterval(handleInterval)
                    }
                }
            }
        }


        return () => {

        }
    }, [mouseOn]);

    useEffect(() => {
        //Swipe Touch Screen
        const getFullWidthPanelWrapperMobile = document.querySelectorAll<HTMLElement>(`.container-full-width .panel-wrapper.mobile`)
            for(let i = 0; i < getFullWidthPanelWrapperMobile.length; i++) {
                const idWrapper = getFullWidthPanelWrapperMobile[i].getAttribute('id')
                if(idWrapper === touchId && touchId != '' && touchEnd) {
                    if(touchStartXValue > touchEndXValue) {
                        slideTransform(getFullWidthPanelWrapperMobile && getFullWidthPanelWrapperMobile, 1, touchId, false, false, true, undefined)
                        navigatePagination(getFullWidthPanelWrapperMobile[i])
                        setTouchEnd(false)
                    } else if (touchStartXValue < touchEndXValue) {
                        slideTransform(getFullWidthPanelWrapperMobile && getFullWidthPanelWrapperMobile, -1, touchId, false, true, false, 2)
                        navigatePagination(getFullWidthPanelWrapperMobile[i])
                        setTouchEnd(false)
                    } else if (touchStartYValue == touchEndYValue || touchStartYValue > touchEndYValue || touchStartYValue < touchEndYValue) {
                        setTouchEnd(false)
                    }
                }
            }
        return () => {
        }
    }, [touchEnd])

    useEffect(() => {
        window.addEventListener("resize", resize);
        return () => {
            window.removeEventListener("resize", resize)
        }
    }, [])

    const resize = () => {
        setTimeout(() => {
            const getFullWidthPanelWrapper = document.querySelectorAll<HTMLElement>(`.container-full-width .panel-wrapper.desktop`)
            prevNextArrowPosition(getFullWidthPanelWrapper && getFullWidthPanelWrapper, false, false)
            for(let i = 0; i < getFullWidthPanelWrapper.length; i++) {
                const getSliceActive = getFullWidthPanelWrapper[i] && getFullWidthPanelWrapper[i].getAttribute('slide-active')
                const getId = getFullWidthPanelWrapper[i] && getFullWidthPanelWrapper[i].getAttribute('id')
                const itemTransform = getSliceActive && parseInt(getSliceActive)+2
                if(itemTransform && getId) {
                    slideTransform(getFullWidthPanelWrapper && getFullWidthPanelWrapper, -itemTransform, getId, true, false, false, undefined)
                }
            }
        }, 300)
    }

    const mouseEnter = (id: any) => {
        setMouseOn(true)
        setMouseOnId(id)
        const getFullWidthPanelWrapperDesktop = document.querySelectorAll<HTMLElement>(`.container-full-width .panel-wrapper.desktop`)

        for(let i = 0; i < getFullWidthPanelWrapperDesktop.length; i++) {
            const getWrapperId = getFullWidthPanelWrapperDesktop[i].getAttribute('id')

            if(getWrapperId === id) {
                const getDataAuto = getFullWidthPanelWrapperDesktop[i].getAttribute('data-auto')
                if(getDataAuto && getDataAuto === 'true') {
                    getFullWidthPanelWrapperDesktop[i].setAttribute('data-auto', 'false')
                    setMouseOnId(id)
                }
            }
        }
    }
    const mouseLeave = (id: any) => {
        setMouseOn(false)
        setMouseOnId('')
        const getFullWidthPanelWrapperDesktop = document.querySelectorAll<HTMLElement>(`.container-full-width .panel-wrapper.desktop`)

        for(let i = 0; i < getFullWidthPanelWrapperDesktop.length; i++) {
            const getWrapperId = getFullWidthPanelWrapperDesktop[i].getAttribute('id')

            if(getWrapperId === id) {
                const getDataAuto = getFullWidthPanelWrapperDesktop[i].getAttribute('data-auto')
                if(getDataAuto && getDataAuto === 'false') {
                    getFullWidthPanelWrapperDesktop[i].setAttribute('data-auto', 'true')
                }
            }
        }
    }

    return (
        <>
        <div className={`panel-section full-width ${props.sectionClassName}`}>
                <div className={`container-full-width ${isMobile ? 'mobile': 'desktop'}`} onMouseEnter={mouseEnter.bind('', props.id)} onMouseLeave={mouseLeave.bind('', props.id)} onTouchStart={(e) => {
                    const startX = e.changedTouches[0].screenX
                    const startY = e.changedTouches[0].screenY
                    if(props.id) {
                        setTouchStartXValue(startX)
                        setTouchStartYValue(startY)
                        setTouchId(props.id)
                    }
                }
                } onTouchEnd={(e) => {
                    const endX = e.changedTouches[0].screenX
                    const endY = e.changedTouches[0].screenY
                    if(props.id) {
                        setTouchEndXValue(endX)
                        setTouchEndYValue(endY)
                        setTouchEnd(true)
                    }

                }}>
                    <div className={`panel-wrapper ${isMobile ? 'mobile': 'desktop'}`} id={`${props.id}`} data-items-init={props.itemLength} slide-active={0} data-auto='true'>
                       {props.panels && props.panels.map((panel: any, idx: number) => {

                        let bgImage;
                        if(panel.backgroundImage?.fields?.file && panel.backgroundGradient) bgImage = `url('${panel.backgroundImage?.fields?.file?.url}')`
                        if(panel.backgroundImage?.fields?.file && !panel.backgroundGradient) bgImage = `url('${panel.backgroundImage?.fields?.file?.url}')`
                        if(!panel.backgroundImage?.fields?.file && panel.backgroundGradient) bgImage = panel.backgroundGradient
                        if(!panel.backgroundImage?.fields?.file && !panel.backgroundGradient) bgImage = `none`
                            return <Link to={`${panel.linkTo ? panel.linkTo : '#'}`}
                            key={idx} className={`panel-card ${panel.cssClassName ? panel.cssClassName : ''} ${panel.linkTo ? 'link-to' : 'no-link'}`} data-index-number={idx}>
                                <div className={`panel-inner`} style={{backgroundImage : `${bgImage}`}}>
                                    {panel.icon?.fields?.file &&
                                    <div className={`icon-wrapper`}><img className={`panel-icon`} src={`${panel.icon?.fields?.file?.url}`} alt={`${panel.name ? panel.name : 'panel-icon'}`} /></div>}
                                    {panel.styledTexts && <div className={`text-wrapper`}>
                                        {panel.styledTexts?.map((s : StyledText) => (
                                            <StyledTextComponent st={s} key={s._id ? s._id : (s as any).id} loggedIn={props.loggedIn}/>
                                        ))}
                                        {panel.jackpotId && <PanelSectionJackpotBanner panel={panel}/>}
                                    </div>}
                                </div>
                            </Link>
                        })}
                    </div>
                    {!isMobile && !props.bottomNavigation && <div className={`panel-navigate full-width`}>{props.renderNavigate}</div>}
                </div>
            {!props.bottomNavigation && (
                <ul className={`splide-pagination ${isMobile ? 'mobile' : 'desktop'}`}>
                    {props.panels.map((item: any, idx: number) => {
                        return <li key={idx}>
                            <button className={`splide-pagination-page`} type="button"></button>
                        </li>
                    })
                    }
                </ul>
            )}
            {props.bottomNavigation && <>{props.renderNavigate}</>}
        </div>
        </>
    )
}

export default PanelSectionFullWidth;
